import { Analytics } from '@plaudit/analytics';

function newsletterSubscriptionForm() {
	var newsletterSignupForm = document.getElementById('mc_embed_signup');
	if (newsletterSignupForm !== null) {
		newsletterSignupForm.addEventListener('DOMSubtreeModified', (event: Event) => {
			var target = event.target as HTMLElement;
			console.log("newsletter sub stumited: ", target.id);
			if (target.id === 'mce-success-response') {
				Analytics.getInstance().trackEvent('Newsletter', 'Signup', undefined, undefined, true);
			} else if (target.id === 'mc-embedded-subscribe-container') {
				//This fixes MailChimp's form not properly re-showing the subscribe button on failed submissions
				var elem = document.getElementById('mc-embedded-subscribe');
				var styleAttr = elem.getAttribute('style');
				if ((typeof styleAttr === 'string')) {
					if (styleAttr.indexOf('display: none;') > -1) {
						elem.setAttribute('style', styleAttr.replace('display: none;', ''));
						target.removeChild(target.querySelector('span'));
					}
				}
			}
		}, false);
	}
}

export default newsletterSubscriptionForm;
